/**
 * InvoiceNotes store timezone-naive UTC wall times ("YYYY-MM-DD HH:mm:ss")
 * or ISO strings with a zone. Display in Europe/Berlin (DST-aware).
 * Stored values are written by formatInvoiceNoteUtcTimestamp() in
 * src/lib/invoices/invoice-note-timestamps.ts.
 *
 * Assigned to window so gulp-concat call sites and lint:new both see them as used.
 */
function luxParseInvoiceNoteStoredTimestamp(stored) {
  if (stored == null || stored === '') return null
  const s = String(stored).trim()
  if (!s) return null
  const hasZone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(s)
  const normalized = hasZone
    ? s
    : `${s.includes('T') ? s : s.replace(' ', 'T')}Z`
  const d = new Date(normalized)
  return Number.isNaN(d.getTime()) ? null : d
}

function luxFormatInvoiceNoteDateTime(stored) {
  const d = luxParseInvoiceNoteStoredTimestamp(stored)
  if (!d) return ''
  return d.toLocaleString('de-DE', {
    timeZone: 'Europe/Berlin',
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

function luxFormatInvoiceNoteNow() {
  return luxFormatInvoiceNoteDateTime(new Date().toISOString())
}

window.luxFormatInvoiceNoteDateTime = luxFormatInvoiceNoteDateTime
window.luxFormatInvoiceNoteNow = luxFormatInvoiceNoteNow
